module.exports = "/static/assets/da61b68758e268acdb29dd76950b76b0.png";